import { LearningObjectiveStatementStatus } from '@exam-management/graphql';
import { CheckCircleOutlinedIcon, DoDisturbAltOutlinedIcon } from '@shared/components';

interface LOSStatusIconProps {
  status: LearningObjectiveStatementStatus;
}

export default function LOSStatusIcon({ status }: Readonly<LOSStatusIconProps>) {
  switch (status) {
    case LearningObjectiveStatementStatus.Published:
      return <CheckCircleOutlinedIcon color='success' sx={{ fontSize: '24px' }} />;
    case LearningObjectiveStatementStatus.Disabled:
      return (
        <DoDisturbAltOutlinedIcon
          sx={(theme) => ({ fontSize: '24px', color: theme.palette.text.disabled })}
        />
      );
    default:
      return null;
  }
}
